<template>
  <DashboardHeaderContainer class="benchmarks-header">
    <div class="actions-content">
      <FilterRow
        class="filter-row"
        :displayLimit="displayLimit"
        @add="$emit('add')"
        @complete="$emit('complete')"
      ></FilterRow>
      <BenchmarksBrandCalendar
        v-if="view === 'brand'"
        :initialDateValue="initialDateValue"
        :comparisonDateRange="comparisonDateRange"
        :comparisonPredefinedRangeValue="comparisonPredefinedRangeValue"
        :minDate="minDate"
        :maxDate="maxDate"
        v-on="$listeners"
      />
      <BenchmarksCategoryCalendar
        v-if="view === 'category'"
        :initialDateValue="initialDateValue"
        :comparisonQuarter="comparisonQuarter"
        :minDate="minDate"
        :maxDate="maxDate"
        v-on="$listeners"
      />
    </div>
  </DashboardHeaderContainer>
</template>

<script>
import DashboardHeaderContainer from '../Common/DashboardHeaderContainer.vue';
import FilterRow from '../Common/FilterRow.vue';
import BenchmarksBrandCalendar from './BenchmarksCalendar/BenchmarksBrandCalendar.vue';
import BenchmarksCategoryCalendar from './BenchmarksCalendar/BenchmarksCategoryCalendar.vue';

export default {
  props: {
    filters: {
      type: Array,
    },
    portfolioBrands: {
      type: Array,
    },
    initialDateValue: {
      type: Object,
    },
    comparisonDateRange: {
      type: Object,
    },
    comparisonPredefinedRangeValue: {
      type: Number,
      default: 0,
    },
    view: {
      type: String,
    },
    comparisonQuarter: {
      type: Number,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    displayLimit: {
      type: Number,
      default: 2,
      validator: val => val >= 0 && val <= 3,
    },
  },
  components: {
    DashboardHeaderContainer,
    FilterRow,
    BenchmarksBrandCalendar,
    BenchmarksCategoryCalendar,
  },
};
</script>

<style scoped>
.benchmarks-header {
  display: flex;
  justify-content: center;
}

.filter-row {
  padding-left: 18px;
}

.actions-content {
  height: 100%;
  width: 1360px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
